import type {
  VendorAuthenticationMethod,
  VendorEnvironmentAccess,
} from '@deepguide-ai/types'

export const CATEGORY_LABELS: Record<string, string> = {
  CLOUD_INFRASTRUCTURE: 'Cloud Infra',
  IDENTITY: 'Identity',
  DATABASE: 'Database',
  MONITORING: 'Monitoring',
  CI_CD: 'Code Repository / CI/CD',
  COMMUNICATION: 'Communication',
  AI: 'AI',
  HR: 'HR',
  SECURITY: 'Security',
  OTHER: 'Other',
}
export type RiskTierFilter = 'all' | 'CRITICAL' | 'HIGH' | 'MEDIUM' | 'LOW'
export type StatusFilter =
  | 'all'
  | 'ACTIVE'
  | 'UNDER_REVIEW'
  | 'OFFBOARDED'
  | 'PENDING_ONBOARDING'
export type CategoryFilter =
  | 'all'
  | 'CLOUD_INFRASTRUCTURE'
  | 'IDENTITY'
  | 'DATABASE'
  | 'MONITORING'
  | 'CI_CD'
  | 'COMMUNICATION'
  | 'AI'
  | 'HR'
  | 'SECURITY'
  | 'OTHER'

export const VENDOR_AUTH_METHOD_LABELS: Record<
  VendorAuthenticationMethod,
  string
> = {
  CREDENTIALS: 'Credentials',
  CREDENTIALS_WITH_MFA: 'Credentials with MFA',
  SSO: 'SSO',
  NOT_APPLICABLE: 'Not applicable',
}

export const VENDOR_ENVIRONMENT_ACCESS_LABELS: Record<
  VendorEnvironmentAccess,
  string
> = {
  NO_ACCESS: 'No access',
  READ_ONLY: 'Read only',
  READ_AND_WRITE: 'Read and write',
}

// Legacy tool/infrastructure values do not establish subprocessor status.
export const VENDOR_SUBPROCESSOR_OPTIONS = [
  { value: '_unknown', label: 'Unknown' },
  { value: 'subprocessor', label: 'Yes' },
  { value: 'not_subprocessor', label: 'No' },
]
